// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_9689d4', '__Roboto_Fallback_9689d4'"},"className":"__className_9689d4","variable":"__variable_9689d4"};